<template>
    <div class="noticeMsgManage">
        <div class="tab">
            <div class="tab-item tab-active">提醒 <span v-if="noticeNum!=0">{{`(${noticeNum})`}}</span></div>
            <div class="tab-item" @click="goto()">消息 <span v-if="msgNum!=0">{{`(${msgNum})`}}</span></div>
        </div>
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item time">
                    <span>提醒开始时间：</span>
                    <el-date-picker v-model="search.date" @change="pageNumber=1,queryMessage()" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li class="conditions_list_item">
                    <span>提醒对象：</span>
                    <el-input v-model="search.name" placeholder="请输入提醒对象" @input="pageNumber=1,queryMessage,queryMessage()">
                    </el-input>
                </li>
                <li class="conditions_list_item">
                    <span>提醒内容：</span>
                    <el-input v-model="search.remindContent" placeholder="请输入提醒内容" @input="pageNumber=1,queryMessage()">
                    </el-input>
                </li>
                <li class="conditions_list_item">
                    <span>状态</span>
                    <el-select v-model="search.status" @change="pageNumber=1,queryMessage()" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li>
                <el-button @click="messageAddShow" type="primary">新增</el-button>
            </ul>
        </div>

        <el-dialog title="消息提醒" :visible.sync="dialogVisible">
            <div class="leaveRequest_content">
                <div class="item">
                    <div class="item_div item_div_user">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒对象：
                        </span>
                        <div style="position:relative">
                            <el-input
                                v-model="form.departmentName"
                                @focus="departpopshow=!departpopshow"
                                placeholder="请选择部门"
                            ></el-input>
                            <div class="departpop" v-show="departpopshow">
                                <el-tree
                                    :default-expand-all="true"
                                    :data="departmentList"
                                    :props="defaultProps"
                                    @node-click="handleNodeClick"
                                >
                                    <span class="custom-tree-node" slot-scope="{ node,data}">
                                        <div>
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='区'"
                                                src="../../assets/icon/quyu.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='店'"
                                                src="../../assets/icon/dian.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='组'"
                                                src="../../assets/icon/zu.png"
                                                alt
                                            />
                                            <span>{{ data.name }}</span>
                                        </div>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                        <div>
                            <el-select v-model="form.remindIds" multiple collapse-tags placeholder="请选择员工" clearable @visible-change="getuser">
                                <el-option v-for="(item,index) in userList" :key="index" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒开始时间：
                        </span>
                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" v-model="form.beginTime" placeholder="请选择"></el-date-picker>
                    </div>
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒结束时间：
                        </span>
                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" v-model="form.endDatetime" placeholder="请选择"></el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒提前：
                        </span>
                        <el-select v-model="form.advanceRemind" placeholder="请选择" clearable>
                            <el-option v-for="(item,index) in advanceRemindList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>重复设置：
                        </span>
                        <el-select v-model="form.frequency" placeholder="请选择" clearable>
                            <el-option v-for="(item,index) in frequencyList" :key="index" :label="item.valueDesc" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">提醒内容：</span>
                        <el-input v-model="form.remindContent" type="textarea" placeholder></el-input>
                    </div>
                </div>
            </div>
            <div class="dialog-foot">
                <button class="foot-cancel" @click="dialogVisible=false">取消</button>
                <button class="foot-save" @click="messageAdd">确定</button>
            </div>
        </el-dialog>

        <el-dialog title="消息提醒" :visible.sync="editdialogVisible">
            <div class="leaveRequest_content">
                <div class="item">
                    <div class="item_div item_div_user">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒对象：
                        </span>
                        <div style="position:relative"></div>
                        <div>{{editform.remindName}}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒开始时间：
                        </span>
                        <div>{{editform.beginTime}}</div>
                    </div>
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒结束时间：
                        </span>
                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" v-model="editform.endDatetime" placeholder="请选择"></el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>提醒提前：
                        </span>
                        <div>{{editform.advanceRemindName}}</div>
                    </div>
                    <div class="item_div">
                        <span class="label">
                            <i class="notice-icon">*</i>重复设置：
                        </span>
                        <el-select :disabled="editform.status=='COMPLETE'" v-model="editform.frequency" placeholder="请选择" clearable>
                            <el-option v-for="(item,index) in frequencyList" :key="index" :label="item.valueDesc" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">提醒内容：</span>
                        <el-input :disabled="editform.status=='COMPLETE'" v-model="editform.remindContent" type="textarea" placeholder></el-input>
                    </div>
                </div>
            </div>
            <div class="dialog-foot" v-if="editform.status!='COMPLETE'">
                <button class="foot-notice" @click="messageClose">关闭</button>
                <span v-if="editform.whether&&editform.statusName!='已过期'">
                    <button class="foot-notice" @click="messageDelete">删除</button>
                    <button class="foot-cancel" @click="editdialogVisible=false">取消</button>
                    <button class="foot-save" @click="messageEdit">确定</button>
                </span>
            </div>
        </el-dialog>

        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" @row-dblclick="editMessage" :header-cell-style="setHeaderStyle">
                <el-table-column prop="beginTime" label="提醒开始时间"></el-table-column>
                <el-table-column prop="endDatetime" label="提醒结束时间"></el-table-column>
                <el-table-column prop="remindName" label="提醒对象"></el-table-column>
                <el-table-column prop="advanceRemindName" label="提醒提前"></el-table-column>
                <el-table-column prop="remindContent" :show-overflow-tooltip="true" width="300" label="提醒内容">
                </el-table-column>
                <el-table-column prop="statusName" label="状态"></el-table-column>
                <el-table-column label="房客源编号">
                    <template slot-scope="scope">
                        <span @click="goDetail(scope.row)" style="color:#5e75e6">{{scope.row.detailId}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="employeeName" label="操作人"></el-table-column>
                <el-table-column prop="inputTime" label="操作时间"></el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageNumber" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import {
    queryMessage,
    messageAdd,
    departmentFind,
    employeeQuery,
    messageEdit,
    messageClose,
    queryMessageNumberMessages,
    messageDelete,
} from "@/api/manageCenter";
import { dicGet } from "@/api/index";
export default {
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        let date = new Date();
        return {
            permisList,
            total: 0,
            userId: sessionStorage.getItem("userId"),
            currentPage: 1,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            // state: "不限", //状态
            List: [], //房源列表
            curImgList: [],
            departpopshow: false,
            dialogVisible: false,
            departmentList: [],
            defaultProps: {
                children: "child",
            },
            userList: [],
            advanceRemindList: [],
            frequencyList: [],
            form: {
                remindIds: [], //提醒人编号
                advanceRemind: "", //提醒提前
                beginTime: "", //开始时间
                endDatetime: "", //结束时间
                frequency: "", //频率
                remindContent: "", //提醒内容
                type: "", //类型
            },
            editdialogVisible: false,
            editform: {
                statusName: "",
                remindName: [], //提醒人姓名
                advanceRemind: "", //提醒提前
                beginTime: "", //开始时间
                endDatetime: "", //结束时间
                frequency: "", //频率
                remindContent: "", //提醒内容
                type: "", //类型
            },
            typeList: [
                {
                    label: "未开始",
                    value: "NO_BEGIN",
                },
                {
                    label: "进行中",
                    value: "GOING",
                },
                {
                    label: "已过期",
                    value: "LATE",
                },
                {
                    label: "已关闭",
                    value: "COMPLETE",
                },
            ],
            //搜索
            search: {
                date: [
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : "0" + (date.getMonth() + 1)) +
                    "-01",
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : "0" + (date.getMonth() + 1)) +
                    "-" +
                    date.getDate(),
                ], //日期区间
                date: "", //提醒开始时间
                name: "", //姓名查询
                remindContent: "", //提醒内容
                status: "", //状态
                type: "REMIND", //消息还是提醒
            },
            noticeNum: 0,
            msgNum: 0,
        };
    },
    components: {},
    mounted() {
        this.queryMessage();
        this.getdepartmentFindAll();
        // this.employeeQuery();
        this.getAdvanceRemind();
        this.getFrequency();
        this.queryMessageNumberMessages();
        console.log(213);
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },

        goto() {
            this.$store.commit("delete_tabs", this.$route.path);
            this.$router.push("messageManage");
        },

        queryMessageNumberMessages() {
            this.$post(queryMessageNumberMessages).then((res) => {
                if (res.success) {
                    this.noticeNum = res.data.lateNumber;
                    this.msgNum = res.data.noReadNumber;
                }
            });
        },

        goDetail(data) {
            if (data.houseCustomer == "CUSTOMER") {
                // 客源编号

                localStorage.setItem("customerId", data.detailId);
                sessionStorage.setItem("employeeId", data.employeeId);
                if (data.transactionType === "WANT_TO_BUY") {
                    this.$store.commit("save_customerType", "WANT_TO_BUY");
                    this.$router.push({ path: "/purchaseDetail" });
                } else {
                    this.$store.commit("save_customerType", "WANT_TO_RENT");
                    this.$router.push({ path: "/purchaseDetail" });
                }
            } else if (data.houseCustomer == "HOUSE") {
                // 房源编号

                if (data.transactionType === "SECONDHAND") {
                    sessionStorage.setItem("sellHousebuildId", data.detailId);
                    this.$store.commit("save_houseType", "SECONDHAND");
                    this.$router.push({ path: "buildDetail" });
                } else if (data.transactionType === "RENTING") {
                    sessionStorage.setItem("rentHousebuildId", data.detailId);
                    this.$store.commit("save_houseType", "RENTING");
                    this.$router.push({ path: "rentingBuildDetail" });
                } else if (data.transactionType === "SHOP_SALE") {
                    sessionStorage.setItem("sellShopbuildId", data.detailId);
                    this.$store.commit("save_houseType", "SHOP_SALE");
                    this.$router.push({ path: "sellShopDetails" });
                } else if (data.transactionType === "SHOP_RENTAL") {
                    sessionStorage.setItem("rentShopbuildId", data.detailId);
                    this.$store.commit("save_houseType", "SHOP_RENTAL");
                    this.$router.push({ path: "rentShopDetails" });
                }
                sessionStorage.setItem("buildId", data.detailId);
                sessionStorage.setItem("employeeId", data.employeeId);
            }
        },

        messageAddShow() {
            this.form = {
                departmentName: "",
                departmentId: "",
                remindIds: [], //提醒人编号
                advanceRemind: "", //提醒提前
                beginTime: "", //开始时间
                endDatetime: "", //结束时间
                frequency: "", //频率
                remindContent: "", //提醒内容
                type: "", //类型
            };
            this.dialogVisible = true;
        },

        getdepartmentFindAll() {
            // 获取部门
            this.$post(departmentFind).then((res) => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.form.departmentId = node.id;
            this.form.departmentName = node.name;
            this.employeeQuery();
            this.departpopshow = false;
        },
      getuser(val){
          if (val){
            if (!this.form.departmentId){
              this.$message.error('请先选择部门！')
            }
          }

      },
        getAdvanceRemind() {
            let params = {
                code: "advanceRemind",
            };
            this.$post(dicGet, params).then((res) => {
                if (res.success) {
                    this.advanceRemindList = res.data;
                }
            });
        },

        getFrequency() {
            let params = {
                code: "frequency",
            };
            this.$post(dicGet, params).then((res) => {
                if (res.success) {
                    this.frequencyList = res.data;
                }
            });
        },

        editMessage(row, column, event) {
            this.editform = Object.assign({}, row);
            this.editform.endDatetime = this.editform.endDatetime + ":00";
            this.editdialogVisible = true;
        },

        messageClose() {
            if (!this.editform.endDatetime) {
                this.$message.error("提醒结束时间不能为空");
                return;
            }
            if (!this.editform.frequency) {
                this.$message.error("重复设置不能为空");
                return;
            }
            let params = Object.assign({}, this.editform);
            this.$post(messageClose, params).then((res) => {
                if (res.success) {
                    this.pageNumber = 1;
                    this.queryMessage();
                    this.editdialogVisible = false;
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        messageDelete() {
            if (!this.editform.endDatetime) {
                this.$message.error("提醒结束时间不能为空");
                return;
            }
            if (!this.editform.frequency) {
                this.$message.error("重复设置不能为空");
                return;
            }
            let params = Object.assign({}, this.editform);
            this.$post(messageDelete, params).then((res) => {
                if (res.success) {
                    this.pageNumber = 1;
                    this.queryMessage();
                    this.editdialogVisible = false;
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        messageEdit() {
            if (!this.editform.endDatetime) {
                this.$message.error("提醒结束时间不能为空");
                return;
            }
            if (!this.editform.frequency) {
                this.$message.error("重复设置不能为空");
                return;
            }
            let params = Object.assign({}, this.editform);
            this.$post(messageEdit, params).then((res) => {
                if (res.success) {
                    this.pageNumber = 1;
                    this.queryMessage();
                    this.editdialogVisible = false;
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        messageAdd() {
            if (this.form.remindIds.length == 0) {
                this.$message.error("提醒对象不能为空");
                return;
            }
            if (!this.form.beginTime) {
                this.$message.error("提醒开始时间不能为空");
                return;
            }
            if (!this.form.endDatetime) {
                this.$message.error("提醒结束时间不能为空");
                return;
            }
            if (!this.form.advanceRemind) {
                this.$message.error("提醒提前不能为空");
                return;
            }
            if (!this.form.frequency) {
                this.$message.error("重复设置不能为空");
                return;
            }
            let params = Object.assign({}, this.form);
            params.remindIds = params.remindIds.join(",");
            this.$post(messageAdd, params).then((res) => {
                if (res.success) {
                    this.pageNumber = 1;
                    this.queryMessage();
                    this.dialogVisible = false;
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        queryMessage() {
            let params = Object.assign({}, this.search);
            params["page.pageSize"] = this.pageSize;
            params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
            this.$post(queryMessage, params).then((res) => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                    this.queryMessageNumberMessages();
                }
            });
        },

        employeeQuery() {
          this.form.remindIds=[]
            var params = {
                departmentId: this.form.departmentId,
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then((res) => {
                if (res.success === true) {
                    this.userList = res.data;
                    this.userList.map(item=>{
                      this.form.remindIds.push(item.id)
                    })
                }
            });
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryMessage();
        },
        handleSizeChange(val) {
            this.pageNumber = 1;
            this.pageSize = val;
            this.queryMessage();
        },

        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
    },
};
</script>
<style type="text/css" lang="less">
.noticeMsgManage {
    background: #ffffff;
    margin: 20px 18px;
    padding: 22px 30px 10px;
    .tab {
        display: flex;
        align-items: center;
        &-item {
            width: 100px;
            height: 36px;
            font-size: 14px;
            line-height: 36px;
            background: #f1f1f1;
            text-align: center;
            cursor: pointer;
            span {
                color: #ff0000;
            }
        }
        &-active {
            background: #ff9e56;
            color: #ffffff;
        }
    }
    .departpop {
        width: 170px;
        position: absolute;
        left: 0px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .notice-icon {
        color: #f56c6c;
        padding-right: 6px;
    }
    .key_list {
        display: flex;
        flex-wrap: wrap;
        .conditions_list_item {
            padding: 0 10px;
            display: flex;
            align-items: center;
            margin: 5px 10px 5px 0;
            position: relative;
            // overflow: hidden;
            cursor: pointer;
            > span {
                font-size: 12px;
                color: #666666;
                padding: 4px 5px 4px 0;
            }
            .el-date-editor {
                margin-left: 10px;
                width: 310px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #dbdbdb;
                .el-range-input {
                    // width: 310px;
                    line-height: 30px;
                    height: 28px;
                    border: none;
                    color: black;
                    padding-left: 30px;
                }
                .el-range-separator {
                    line-height: 26px;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 80px;

                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 80px;
                        height: 30px;
                        color: black;
                        padding: 0 5px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .shop {
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 100px;
                        height: 30px;
                        border: none;
                        color: black;
                        padding: 0;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }
    }

    .key_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        background: #fff;
        .el-input {
            width: 145px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
                padding: 0 10px;
                border: none;
            }

            .el-input__inner {
                height: 30px;
            }

            .icon-icon_sousuo {
                color: white;
            }
        }

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }

        //弹出框样式
        .el-dialog {
            width: 500px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }
    }
    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }

    .el-dialog {
        width: 800px;

        .el-dialog__title {
            color: #5e75e6;
            font-size: 20px;
        }

        .el-dialog__close {
            font-size: 26px;
        }

        .el-dialog__body {
            padding-left: 30px;
            padding-right: 30px;
            padding-bottom: 0;
            .leaveRequest_content {
                padding: 20px 30px 0 30px;
                .item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &_div_user {
                        .el-select {
                            .el-select__tags {
                            }
                            .el-input {
                                width: 200px;
                                // height: 26px;
                                margin-right: 20px;
                                .el-input__inner {
                                    padding: 0 10px;
                                    // height: 26px;
                                }
                            }
                        }
                    }
                    &_div {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        .label {
                            min-width: 100px;
                            display: inline-block;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            text-align: right;
                            .notice {
                                color: #ff0000;
                            }
                        }
                        .iconfont1 {
                            color: #90b5ff;
                        }
                        .item_list {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            flex-wrap: wrap;
                            & > div {
                                margin-top: 10px;
                            }
                        }
                        .person {
                            display: inline-block;
                            width: 54px;
                            height: 54px;
                            line-height: 54px;
                            margin: 0 2px;
                            text-align: center;
                            background: rgba(144, 181, 255, 1);
                            border-radius: 50%;
                            color: #ffffff;
                        }
                        .el-input__icon {
                            line-height: 26px;
                        }
                        .el-input {
                            width: 120px;
                            height: 26px;
                            margin-right: 20px;
                            .el-input__inner {
                                padding: 0 10px;
                                height: 26px;
                            }
                        }
                        .el-date-editor {
                            width: 200px;
                            .el-input__inner {
                                width: 200px;
                                padding: 0 30px;
                                height: 26px;
                                line-height: 26px;
                            }
                        }
                    }
                }
            }
            .dialog-foot {
                text-align: right;
                margin-top: 50px;
                background: #f5f5f5;
                padding: 20px;
                .foot-notice,
                .foot-cancel,
                .foot-save {
                    width: 80px;
                    height: 40px;
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-right: 20px;
                }
                .foot-notice {
                    background: rgb(245, 108, 108);
                }
                .foot-cancel {
                    background: #cccccc;
                }
                .foot-save {
                    background: #5e75e6;
                }
            }
        }
    }

    .key_list_wrap {
        height: 90%;

        .footer_page {
            position: relative !important;
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }

    .mask .el-carousel__item {
        background: transparent;
        opacity: 1!important;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9;
        .close {
            width: 20px;
            position: absolute;
            top: 0;
            right: 300px;
            padding: 50px;
            z-index: 100;
        }
        .delet {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 100px;
            z-index: 100;
            height: auto !important;
        }
        .edit {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 240px;
            z-index: 100;
            height: auto !important;
        }

        .el-carousel__container {
            width: 80%;
            margin: 200px auto;
            height: 100%;
            z-index: 99;
            .el-carousel__arrow {
                font-size: 50px !important;
                padding: 20px;
                width: 100px;
                height: 100px;
            }
            // .el-carousel__arrow--left,.el-carousel__arrow--right{

            // }
        }

        .el-carousel__item {
            color: #475669;
            font-size: 18px;
            opacity: 0.75;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            // min-height: 400px;
            .uploadtime {
                width: 100%;
                line-height: 24px;
                color: #fff;
                position: absolute;
                left: 100px;
                bottom: 0;
            }
            > img {
                width: 90%;
            }
        }
        .door_modle_introduced {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            padding: 0 100px;
            .introduced_toward {
                display: flex;
                flex-direction: column;
                > span {
                    font-size: 14px;
                    color: #ffffff;
                }

                .el-textarea {
                    margin-top: 10px;
                    .el-textarea__inner {
                        width: 260px;
                        height: 60px;
                        background: #f5f5f5;
                        border: 1px solid #ccc;
                    }
                }
            }
            .el-select {
                margin-top: 10px;
                .el-input {
                    .el-input__inner {
                        padding-left: 10px !important;
                        font-size: 16px !important;
                        width: 100px !important;
                        height: 30px !important;
                        line-height: 30px !important;
                        background: #f5f5f5;
                        border: 1px solid #ccc !important;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #99a9bf;
        // }

        // .el-carousel__item:nth-child(2n+1) {
        //   background-color: #d3dce6;
        // }
    }
}
</style>
